import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { copyObject } from 'src/modules/shared/utils/utility';
import { IOfficeAddRequest, OfficeAddRequest } from "../../../shared/interfaces/IOfficeAddRequest";

@Component({
  selector: 'app-offices-details',
  templateUrl: './offices-details.component.html',
  styleUrls: ['./offices-details.component.css'],
})
export class OfficesDetailsComponent implements OnInit {
  private INITIAL_STATE: IOfficeAddRequest = OfficeAddRequest;

  isNoRequests = false;
  @Input() Requests: IOfficeAddRequest[] = [];
  @Input() readonly: boolean = false;
  @Input() showError: boolean;
  @ViewChild('AddForm') addFormModel: NgForm;

  invalid: boolean = false;

  isEditMode = false;
  isAddingNewSystem = false;
  currentEditIndex = -1;
  currentRequests: IOfficeAddRequest = this.getInitialState();

  constructor(private activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {}

  handleAddingNewRecordClick() {
    this.isAddingNewSystem = true;
  }

  checkRequests() {
    this.isNoRequests = this.Requests.length < 1;
  }
  onDelete(index: number) {
    if (this.Requests.length != 1) this.Requests.splice(index, 1);
    else if (this.Requests.length == 1 && index == 0) this.Requests.shift();
    this.resetComponent();
    this.checkRequests();
  }

  onEdit(index: number) {
    this.currentRequests = copyObject(this.Requests[index]);
    this.currentEditIndex = index;
    this.isAddingNewSystem = true;
    this.isEditMode = true;
  }

  onSave() {
    if (this.addFormModel.invalid) {
      this.invalid = true;
      return null;
    }
    if (this.isEditMode) {
      this.Requests[this.currentEditIndex] = this.currentRequests;
    } else {
      this.Requests.push(this.currentRequests);
    }
    this.resetComponent();
    this.checkRequests();
  }

  onCancel() {
    this.resetComponent();
  }

  private resetComponent() {
    this.currentRequests = this.getInitialState();
    this.isAddingNewSystem = false;
    this.isEditMode = false;
    this.currentEditIndex = -1;
  }

  getInitialState() {
    return copyObject(this.INITIAL_STATE);
  }

  onChangeToggle(data) {
    this.currentRequests.IsMainOffice = data;
  }
}
